import dayjs from "dayjs"
import { Bar, BarChart, CartesianGrid, LabelList, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"

export default function BarChartVolumePorHora({ data }: iPropsVolumePorHora) {
    function handleData(dados: any[]) {
        // const horas = [
        //     { hour: 0, count: 59 },  { hour: 1, count: 86 },
        //     { hour: 2, count: 52 },  { hour: 3, count: 89 },
        //     { hour: 4, count: 12 },  { hour: 5, count: 93 },
        //     { hour: 6, count: 79 },  { hour: 7, count: 67 },
        //     { hour: 8, count: 89 },  { hour: 9, count: 2 },
        //     { hour: 10, count: 62 }, { hour: 11, count: 41 },
        //     { hour: 12, count: 3 },  { hour: 13, count: 97 },
        //     { hour: 14, count: 4 },  { hour: 15, count: 14 },
        //     { hour: 16, count: 53 }, { hour: 17, count: 5 },
        //     { hour: 18, count: 43 }, { hour: 19, count: 8 },
        //     { hour: 20, count: 0 },  { hour: 21, count: 21 },
        //     { hour: 22, count: 72 }, { hour: 23, count: 20 }
        // ]
        let horas = [
            { hour: 0, count: 0, porcentagem: "0%" },  { hour: 1, count: 0, porcentagem: "0%" },
            { hour: 2, count: 0, porcentagem: "0%" },  { hour: 3, count: 0, porcentagem: "0%" },
            { hour: 4, count: 0, porcentagem: "0%" },  { hour: 5, count: 0, porcentagem: "0%" },
            { hour: 6, count: 0, porcentagem: "0%" },  { hour: 7, count: 0, porcentagem: "0%" },
            { hour: 8, count: 0, porcentagem: "0%" },  { hour: 9, count: 0, porcentagem: "0%" },
            { hour: 10, count: 0, porcentagem: "0%" }, { hour: 11, count: 0, porcentagem: "0%" },
            { hour: 12, count: 0, porcentagem: "0%" }, { hour: 13, count: 0, porcentagem: "0%" },
            { hour: 14, count: 0, porcentagem: "0%" }, { hour: 15, count: 0, porcentagem: "0%" },
            { hour: 16, count: 0, porcentagem: "0%" }, { hour: 17, count: 0, porcentagem: "0%" },
            { hour: 18, count: 0, porcentagem: "0%" }, { hour: 19, count: 0, porcentagem: "0%" },
            { hour: 20, count: 0, porcentagem: "0%" }, { hour: 21, count: 0, porcentagem: "0%" },
            { hour: 22, count: 0, porcentagem: "0%" }, { hour: 23, count: 0, porcentagem: "0%" }
        ]

        let totalRegs = dados.length

        for (let reg of dados) {
            const data_criacao = dayjs(reg.timestamp)

            let pesquisa = horas.filter(reg => reg.hour === data_criacao.get("hour"))
            let existe = pesquisa.length > 0 ? true : false

            if (existe) {
                let index = horas.indexOf(pesquisa[0])
                if (index < 0) {
                    continue
                }
                horas[index].count = horas[index].count + 1
                horas[index].porcentagem = `${((horas[index].count * 100) / totalRegs).toFixed(2)}%`
            }
        }

        return horas
    }
    
    return (
        <div id="graph_horas" className="graph_backgrounds">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                width={500}
                height={300}
                data={handleData(data)}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="hour" />
                    <YAxis dataKey="count" />
                    <Tooltip />
                    <Bar dataKey="count" fill="#128FE2" activeBar={<Rectangle fill="gold" stroke="purple" />} label={{fill: "black"}}>
                        <LabelList dataKey="porcentagem" content={renderCustomizedLabel} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
interface iPropsVolumePorHora {
    data: any[]
}

const renderCustomizedLabel = (props:any) => {
    const { x, y, width, value } = props;
    const radius = 10;
    return (
      <g>
        <text x={x + width / 2} y={y - radius} fill="#000" textAnchor="middle" dominantBaseline="middle">
          {value}
        </text>
      </g>
    );
};
